import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./formInput.scss";
/*
 * Form Input Component
 */
const FormInput = ({ label, value, type, onChange, size, subLabel, className, name, max, decimalOnly, min, required, pattern, inputMode, placeholder, }) => {
    const onInputChange = (e) => {
        onChange(e.target.value, e.target.name);
    };
    const onKeyDown = (e) => {
        if (decimalOnly) {
            if (e.key === ".") {
                e.preventDefault();
            }
        }
    };
    return (_jsxs("div", { className: className, children: [label && (_jsx("label", { className: "input-form-control__label", htmlFor: `input${label}`, children: label })), _jsxs("div", { className: "input-wrapper", children: [_jsx("input", { id: `input${label}`, className: "input-form-control", style: { width: subLabel ? "60%" : "100%" }, type: type || "text", value: value, onChange: onInputChange, size: size || 3, name: name, min: min || undefined, max: max || undefined, onKeyDown: onKeyDown, required: required || false, pattern: pattern || undefined, inputMode: inputMode || undefined, autoComplete: "on", placeholder: placeholder || "" }), subLabel && _jsx("span", { className: "input-form-control__sublabel", children: subLabel })] })] }));
};
export default FormInput;
